import { BlogSection } from '@/types/blog';

export const dopamin: BlogSection = {
  id: 'dopamin',
  title: 'Dopamin & Co.: Dein Gehirn liebt Musik',
  content: `
    <p>
      Musik aktiviert dein Belohnungssystem und löst die Ausschüttung von Dopamin aus – unserem „Glückshormon". Dieses Signal sagt deinem Gehirn: „Behalte diesen Zustand." Und genau hier entsteht Raum für rationale Reflexion: Die emotionale Anspannung löst sich, und dein präfrontaler Cortex kann wieder klar denken statt impulsiv zu reagieren.
    </p>
  `
};
